import React from 'react';
import { FaUsers, FaCog, FaChalkboardTeacher, FaLaptop, FaBlender } from 'react-icons/fa';

const ServicesSection = () => {
  const services = [
    {
      icon: FaUsers,
      title: 'Interentreprises',
      description: 'Il s\'agit avant tout de formations concrètes, animées par les meilleurs experts, qui encouragent l\'acquisition et le développement de compétences "terrain", opérationnelles et directement transposables en entreprise.',
      features: ['Formations concrètes', 'Experts qualifiés', 'Compétences terrain', 'Groupes mixtes'],
      color: '#2c5aa0',
      gradient: 'linear-gradient(135deg, #2c5aa0 0%, #5e4caf 100%)'
    },
    {
      icon: FaCog,
      title: 'Intra & sur mesure',
      description: 'Ce sont des formations sur mesure qui sont adaptées aux attentes de votre entreprise. Nous nous attachons à faire vivre à nos stagiaires des expériences originales et innovantes, pour les rendre acteurs de leur formation.',
      features: ['Formation personnalisée', 'Adaptée à vos besoins', 'Expériences innovantes', 'Flexibilité totale'],
      color: '#f59e0b',
      gradient: 'linear-gradient(135deg, #f59e0b 0%, #f97316 100%)'
    },
    {
      icon: FaChalkboardTeacher,
      title: 'Présentiel / Classes Virtuelles',
      description: 'Il vous permet de vous concentrer durant 1 à 15 jours consécutifs sur un thème et d\'approfondir le sujet avec vos pairs. Une partie importante de la session est consacrée au partage des acquis et des expériences.',
      features: ['1 à 15 jours', 'Formation intensive', 'Partage d\'expériences', 'Interaction directe'],
      color: '#10b981',
      gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
    },
    {
      icon: FaLaptop,
      title: 'E-learning',
      description: 'Des ressources pédagogiques accessibles en ligne 24h/24 pour se former à son rythme. Des webconférences (disponibles en replay) qui permettent aux stagiaires d\'échanger en direct avec nos Consultants-Experts.',
      features: ['Accessible 24h/24', 'À votre rythme', 'Webconférences live', 'Replays disponibles'],
      color: '#8b5cf6',
      gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)'
    },
    {
      icon: FaBlender,
      title: 'Blended Learning',
      description: 'Ce mode d\'apprentissage désigne l\'utilisation conjointe du E-Learning et du mode classique d\'apprentissage : "présentiel". Le stagiaire va ainsi alterner des sessions à distance en ligne et des sessions en face-à-face.',
      features: ['E-learning + Présentiel', 'Formation hybride', 'Apprentissage optimal', 'Flexibilité maximale'],
      color: '#ec4899',
      gradient: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)'
    }
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

        .services-section-wrapper {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
          padding: 100px 0;
          position: relative;
          overflow: hidden;
          margin-top: -70px;
        }

        .services-section-wrapper::before {
          content: '';
          position: absolute;
          top: 0;
          right: -10%;
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(44, 90, 160, 0.05) 0%, transparent 70%);
          border-radius: 50%;
        }

        .services-section-wrapper::after {
          content: '';
          position: absolute;
          bottom: -10%;
          left: -5%;
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(245, 158, 11, 0.05) 0%, transparent 70%);
          border-radius: 50%;
        }

        .services-container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 24px;
          position: relative;
          z-index: 1;
        }

        .services-header {
          text-align: center;
          margin-bottom: 70px;
        }

        .services-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
          color: #fd7e14;
          padding: 10px 24px;
          border-radius: 50px;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 24px;
          border: 1px solid rgba(44, 90, 160, 0.1);
        }

        .services-title {
          font-size: 48px;
          font-weight: 800;
          color: #198754;
          margin-bottom: 16px;
          letter-spacing: -1px;
          line-height: 1.2;
        }

        .services-title-gradient {
          background: linear-gradient(135deg, #198754 0%, #5e4caf 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .services-subtitle {
          font-size: 18px;
          color: #718096;
          max-width: 800px;
          margin: 0 auto;
          line-height: 1.7;
        }

        .services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 32px;
          margin-bottom: 40px;
        }

        .service-card {
          background: white;
          border-radius: 24px;
          padding: 40px 32px;
          border: 1px solid rgba(0, 0, 0, 0.06);
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
        }

        .service-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: var(--card-gradient);
          transform: scaleX(0);
          transition: transform 0.4s ease;
        }

        .service-card:hover::before {
          transform: scaleX(1);
        }

        .service-card:hover {
          transform: translateY(-12px);
          box-shadow: 0 24px 60px rgba(0, 0, 0, 0.12);
          border-color: transparent;
        }

        .service-card.featured {
          grid-column: span 2;
        }

        .service-icon-wrapper {
          width: 80px;
          height: 80px;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--card-gradient);
          margin-bottom: 24px;
          position: relative;
          transition: all 0.4s ease;
        }

        .service-card:hover .service-icon-wrapper {
          transform: scale(1.1) rotate(-5deg);
          box-shadow: 0 16px 40px rgba(0, 0, 0, 0.15);
        }

        .service-icon-wrapper::after {
          content: '';
          position: absolute;
          top: -3px;
          left: -3px;
          right: -3px;
          bottom: -3px;
          background: var(--card-gradient);
          border-radius: 20px;
          opacity: 0;
          filter: blur(12px);
          transition: opacity 0.4s ease;
          z-index: -1;
        }

        .service-card:hover .service-icon-wrapper::after {
          opacity: 0.5;
        }

        .service-icon {
          font-size: 36px;
          color: white;
        }

        .service-title {
          font-size: 22px;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 16px;
          transition: color 0.3s ease;
        }

        .service-card:hover .service-title {
          color: var(--card-color);
        }

        .service-description {
          font-size: 15px;
          color: #718096;
          line-height: 1.7;
          margin-bottom: 24px;
        }

        .service-features {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .feature-item {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14px;
          color: #4a5568;
          font-weight: 500;
        }

        .feature-check {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: var(--card-gradient);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 12px;
          flex-shrink: 0;
          transition: transform 0.3s ease;
        }

        .service-card:hover .feature-check {
          transform: scale(1.1);
        }

        .service-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-top: 20px;
          color: var(--card-color);
          font-weight: 600;
          font-size: 15px;
          text-decoration: none;
          transition: all 0.3s ease;
          opacity: 0;
          transform: translateY(10px);
        }

        .service-card:hover .service-link {
          opacity: 1;
          transform: translateY(0);
        }

        .service-link:hover {
          gap: 12px;
        }

        .cta-banner {
          background: linear-gradient(135deg, #198754 0%, #fd7e14 100%);
          border-radius: 24px;
          padding: 60px 48px;
          text-align: center;
          color: white;
          position: relative;
          overflow: hidden;
        }

        .cta-banner::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -20%;
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
          border-radius: 50%;
        }

        .cta-content {
          position: relative;
          z-index: 1;
        }

        .cta-title {
          font-size: 36px;
          font-weight: 800;
          margin-bottom: 16px;
          line-height: 1.2;
        }

        .cta-text {
          font-size: 18px;
          opacity: 0.95;
          margin-bottom: 32px;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
        }

        .cta-buttons {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .cta-button {
          padding: 16px 40px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 10px;
          font-family: inherit;
          border: none;
        }

        .cta-button-primary {
          background: white;
          color: #2c5aa0;
        }

        .cta-button-primary:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 32px rgba(255, 255, 255, 0.3);
        }

        .cta-button-secondary {
          background: transparent;
          color: white;
          border: 2px solid white;
        }

        .cta-button-secondary:hover {
          background: white;
          color: #2c5aa0;
          transform: translateY(-3px);
        }

        @media (max-width: 968px) {
          .services-section-wrapper {
            padding: 80px 0;
          }

          .services-title {
            font-size: 36px;
          }

          .services-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 24px;
          }

          .service-card.featured {
            grid-column: span 1;
          }

          .cta-banner {
            padding: 48px 32px;
          }

          .cta-title {
            font-size: 28px;
          }
        }

        @media (max-width: 640px) {
          .services-container {
            padding: 0 16px;
          }

          .services-title {
            font-size: 28px;
          }

          .services-subtitle {
            font-size: 16px;
          }

          .services-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }

          .service-card {
            padding: 32px 24px;
          }

          .cta-banner {
            padding: 40px 24px;
          }

          .cta-title {
            font-size: 24px;
          }

          .cta-text {
            font-size: 16px;
          }

          .cta-buttons {
            flex-direction: column;
          }

          .cta-button {
            width: 100%;
            justify-content: center;
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .service-card {
          animation: fadeInUp 0.6s ease-out backwards;
        }

        .service-card:nth-child(1) {
          animation-delay: 0.1s;
        }

        .service-card:nth-child(2) {
          animation-delay: 0.2s;
        }

        .service-card:nth-child(3) {
          animation-delay: 0.3s;
        }

        .service-card:nth-child(4) {
          animation-delay: 0.15s;
        }

        .service-card:nth-child(5) {
          animation-delay: 0.25s;
        }
      `}</style>

      <section className="services-section-wrapper">
        <div className="services-container">
          {/* Header */}
          <div className="services-header">
            <div className="services-badge">
              🎓 Nos Modalités de Formation
            </div>
            <h2 className="services-title">
              Choisissez le format qui <br />
              <span className="services-title-gradient">vous correspond</span>
            </h2>
            <p className="services-subtitle">
              CINEF vous propose une large gamme de modalités de formation pour s'adapter à vos 
              contraintes et objectifs. De la formation en présentiel au e-learning, en passant par 
              le blended learning, trouvez la solution qui vous convient.
            </p>
          </div>

          {/* Services Grid */}
          <div className="services-grid">
            {services.map((service, index) => {
              const Icon = service.icon;
              return (
                <div
                  key={index}
                  className={`service-card ${index === 0 ? 'featured' : ''}`}
                  style={{
                    '--card-gradient': service.gradient,
                    '--card-color': service.color
                  }}
                >
                  <div className="service-icon-wrapper">
                    <Icon className="service-icon" />
                  </div>
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  
                  <div className="service-features">
                    {service.features.map((feature, fIndex) => (
                      <div key={fIndex} className="feature-item">
                        <div className="feature-check">✓</div>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>

                  {/* <a href={`/formations/${service.title.toLowerCase().replace(/\s+/g, '-')}`} className="service-link">
                    En savoir plus
                    <span>→</span>
                  </a> */}
                </div>
              );
            })}
          </div>

          {/* CTA Banner */}
          <div className="cta-banner">
            <div className="cta-content">
              <h3 className="cta-title">
                Besoin d'aide pour choisir ?
              </h3>
              <p className="cta-text">
                Nos conseillers sont à votre disposition pour vous guider vers la formation 
                et le format les mieux adaptés à vos besoins et objectifs professionnels.
              </p>
              <div className="cta-buttons">
                <a href="/contact" className="cta-button cta-button-primary">
                  Contacter un conseiller
                  <span>→</span>
                </a>
                <a href="https://www.cinef-bj.com/formations/docs/catalogue_cinef_2026.pdf" target='_blank' rel="noopener noreferrer" className="cta-button cta-button-secondary">
                  Voir le catalogue complet
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesSection;